// extracted by mini-css-extract-plugin
module.exports = {"block":"EmailConfirmed_block__3JKZQ","title":"EmailConfirmed_title__3kHkU"};